export const DEFAULT_IMAGE_MODEL = 'realvis-xl-v4';

export const OVERLAY_TEXT_FONTS = {
  lato: 'Lato',
  roboto: 'Roboto',
  oswald: 'Oswald',
  bebasNeue: 'Bebas Neue',
  openSans: 'Open Sans',
  poppins: 'Poppins',
  montserrat: 'Montserrat',
  raleway: 'Raleway',
  playfairDisplay: 'Playfair Display',
  nunito: 'Nunito',
};

export const DEFAULT_IMAGE_ASPECT_RATIO = '1_1';

export const DEFAULT_IMAGE_OVERLAY_PROPERTIES = {
  text: '',
  verticalPlacement: 'bottom',
  horizontalPlacement: 'center',
  color: '#ffffff',
  fontSize: 36,
  fontFamily: 'lato',
};

export const IMAGE_ASPECT_RATIO = {
  '1_1': '1_1',
  '16_9': '16_9',
  '9_16': '9_16',
  '4_3': '4_3',
};

export const IMAGE_ASPECT_RATIO_TEXT = {
  [IMAGE_ASPECT_RATIO['1_1']]: 'Square 1:1',
  [IMAGE_ASPECT_RATIO['16_9']]: 'Landscape 16:9',
  [IMAGE_ASPECT_RATIO['9_16']]: 'Portrait 9:16',
  [IMAGE_ASPECT_RATIO['4_3']]: 'Wide 4:3',
};

export const simulateDownloadImageClick = (uri, filename) => {
  const link = document.createElement('a');
  if (typeof link.download !== 'string') {
    window.open(uri);
  } else {
    link.href = uri;
    link.download = filename;
    accountForFirefox(clickLink, link);
  }
};

const clickLink = (link) => {
  link.click();
};

const accountForFirefox = (click, link) => {
  // wrapper function
  document.body.appendChild(link);
  click(link);
  document.body.removeChild(link);
};
